import { render, staticRenderFns } from "./TradePeriod.vue?vue&type=template&id=048dbeb1"
import script from "./TradePeriod.vue?vue&type=script&lang=js"
export * from "./TradePeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports